import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { DatePipe } from '@angular/common';
import { Message, ConfirmationService, ConfirmEventType, MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { MsPermissionService } from 'src/app/services/ms-permission.service';

@Component({
  selector: 'app-ms-factor-reports',
  templateUrl: './ms-factor-reports.component.html',
  styleUrls: ['./ms-factor-reports.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']

})
export class MsFactorReportsComponent {

  isInternalPM: boolean = false;
  statusType: string = 'Pending';
  header: string = this.translate("Factors History - Reports");
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/project',
    }
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Factors History - Reports'), link: '/ms/factor-reports' },
  ];
  messages: Message[] = [];
  projects: any[] = [];
  factors: any[] = [];
  hasBranches: boolean = false;

  skelition: boolean = true;
  isVendor: boolean = false;

  selectProject: any
  selectChanel: any
  selectBranch: any
  selectFactor: any

  project: any;
  channels: Array<any> = []
  basicChannels: Array<any> = []
  branchChannels: Array<any> = []
  branches: Array<any> = []
  selectedBranches: any[] = [];
  filteredFactors: any[] = [];
  factorHistory: any;
  viewHistory: boolean = false;



  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.skelition = true;
    this.getProjects().then(() => {
    }).then(() => {
      let pm = MsPermissionService.checkUserPermissions(this.project);
      if (pm == true) {
        this.isInternalPM = true;
      } else if (pm == false) {
        this.router.navigate(['/ms/project'])
        return;
      }
      this.skelition = false;
    }).catch((error) => {
    });
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes} ${day}-${month}-${year}`;
  }

  async getProjects() {
    try {
      let url = 'ms-project';
      if (this.isVendor) {
        let userId = localStorage.getItem('uid');
        if (userId) {
          url += ('/' + userId);
        } else {
          return;
        }
      }
      let res = await this.dataService.getData(url + `/1/1000`)
      if (res.error) {
        this.skelition = false;
        console.log(res.error);
        return;
      }
      this.projects = res.data.data;
      this.skelition = false;
    } catch (e) {
      console.log(e);
    }
  }

  onProjectChange() {
    let id = this.selectProject._id;
    this.viewHistory = false;
    this.getProject(id);
    this.getFactorData(id);
  }

  onChannelChange() {
    this.viewHistory = false;
    this.filteredFactors = this.factors.filter((factor: { channel: any; }) => factor.channel === this.selectChanel._id);
  }

  onBranchChange() {
    this.viewHistory = false;
    this.filteredFactors = this.factors.filter((factor: { branch: any; }) => factor.branch === this.selectBranch._id);
  }

  async getProject(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels;
      this.basicChannels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.hasBranches = this.basicChannels.some(channel => channel.name === "Branches");
      this.selectedBranches = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getFactorData(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-evaluation/factor-view/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.factors = res.data.map((f: any) => {
        f.factors.grade = (f.factors.grade.reduce((acc: number, currentValue: number) => acc + currentValue, 0)) / f.factors.grade.length;
        f.factors.percentage = (f.factors.percentage.reduce((acc: number, currentValue: number) => acc + currentValue, 0)) / f.factors.percentage.length
        f.factors.msComments = f.factors.msComments.join(', ')
        return f;
      });
      this.filteredFactors = this.factors;
      console.log('FACTORS', this.factors)
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async LoadHistory(id: string) {
    this.factorHistory = [];
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-factor-logs/factor/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.factorHistory = res.data;
      this.viewHistory = true;
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  getResponsibleName(id: string) {
    let responsible = this.selectProject.responsibles.filter((responsible: { user: any; }) => responsible.user === id);
    if (responsible.length > 0) {
      return this.extractUsername(responsible[0].name)
    }
    else {
      return '';
    }
  }

  extractUsername(name: any) {
    if (name) {
      return name.first + ' ' + name.middle + ' ' + name.last;
    }
    return ''
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

}
